import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import VerifyEmail from './pages/VerifyEmail';
import AddExam from './pages/AddExam';
import ExamDetail from './pages/ExamDetail';
import EditExam from './pages/EditExam';
import Profile from './pages/Profile';
import Goals from './pages/Goals';
import CompareExams from './pages/CompareExams';
import ForgotPassword from './pages/ForgotPassword';
import ResetPassword from './pages/ResetPassword';
import PendingApproval from './pages/PendingApproval';
import EmailVerificationPending from './pages/EmailVerificationPending';
import AdminDashboard from './pages/AdminDashboard';
import AllExams from './pages/AllExams';
import AIAnalysisPage from './pages/AIAnalysisPage';
import StudyProgramPage from './pages/StudyProgramPage';
import StudyProgramHistory from './pages/StudyProgramHistory';
import StudyLog from './pages/StudyLog';
import AytJourneyPage from './pages/AytJourneyPage';
import TopicDetailPage from './pages/TopicDetailPage';

function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/verify-email/:token" element={<VerifyEmail />} />
          <Route
            path="/pending-approval"
            element={
              <PrivateRoute>
                <PendingApproval />
              </PrivateRoute>
            }
          />
          <Route
            path="/verify-email-pending"
            element={
              <PrivateRoute>
                <EmailVerificationPending />
              </PrivateRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <PrivateRoute>
                <AdminDashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Dashboard />
              </PrivateRoute>
            }
          />
          <Route
            path="/add-exam"
            element={
              <PrivateRoute>
                <AddExam />
              </PrivateRoute>
            }
          />
          <Route
            path="/exam/:id"
            element={
              <PrivateRoute>
                <ExamDetail />
              </PrivateRoute>
            }
          />
          <Route
            path="/exam/:id/ai-analysis"
            element={
              <PrivateRoute>
                <AIAnalysisPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/edit-exam/:id"
            element={
              <PrivateRoute>
                <EditExam />
              </PrivateRoute>
            }
          />
          <Route
            path="/profile"
            element={
              <PrivateRoute>
                <Profile />
              </PrivateRoute>
            }
          />
          <Route
            path="/goals"
            element={
              <PrivateRoute>
                <Goals />
              </PrivateRoute>
            }
          />
          <Route
            path="/compare-exams"
            element={
              <PrivateRoute>
                <CompareExams />
              </PrivateRoute>
            }
          />
          <Route
            path="/exams"
            element={
              <PrivateRoute>
                <AllExams />
              </PrivateRoute>
            }
          />
          <Route
            path="/study-program"
            element={
              <PrivateRoute>
                <StudyProgramPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/study-program/history"
            element={
              <PrivateRoute>
                <StudyProgramHistory />
              </PrivateRoute>
            }
          />
          <Route
            path="/study-program/:id"
            element={
              <PrivateRoute>
                <StudyProgramPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/study-log"
            element={
              <PrivateRoute>
                <StudyLog />
              </PrivateRoute>
            }
          />
          <Route
            path="/ayt-journey"
            element={
              <PrivateRoute>
                <AytJourneyPage />
              </PrivateRoute>
            }
          />
          <Route
            path="/ayt-journey/topic/:topicProgressId"
            element={
              <PrivateRoute>
                <TopicDetailPage />
              </PrivateRoute>
            }
          />
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
        </Routes>
      </Router>
    </AuthProvider>
  );
}

export default App;
